// extracted by mini-css-extract-plugin
export default {"wrapper":"LabelMenu_wrapper__LrZJg"};